import { api } from "../../../services/api";
import {
  AUTHENTICATE_LOGIN_ACTIONS,
  AUTHENTICATE_REFRESH_TOKEN_ACTIONS,
  AUTHENTICATE_REGISTER_ACTIONS,
  AUTHENTICATE_LOGOUT_ACTIONS,
  AUTHENTICATE_RESET_ACTIONS,
  AUTHENTICATE_ACTIVATE_ACTIONS,
  AUTHENTICATE_NOTIFICATION_ACTIONS,
  AUTHENTICATE_DEVICE_LOGOUT_ACTIONS,
  IS_USER_EXITS_ACTIONS,
  AUTHENTICATE_OAUTH_LOGIN_ACTIONS
} from "../../actionType/authenticate";
import { authenticate } from "../../../services/apiVariables";
import { Toast } from "../../../services/toast";
import { AUTHENTICATE_CHANGE_ACTIONS, AUTHENTICATE_FORGOT_ACTIONS, AUTHENTICATE_RESENDEMAIL_ACTIONS, CHANGE_ACCOUNT_PASSWORD_ACTIONS, IS_USER_NAME_OR_EMAIL_AVAILABLE_ACTIONS, REMOVE_NOTIFICATION_ACTIONS, REQUEST_EMAIL_CHANGE_ACTIONS, AUTHENTICATE_GETEMAIL_OTP_ACTIONS } from "../../actionType/authenticate";
import { useSelector } from "react-redux";
import { stopTokenRefresh } from "@/lib/auth";
useSelector
export const getAuthenticateLogin =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: AUTHENTICATE_LOGIN_ACTIONS.AUTHENTICATE_LOGIN_REQUEST,
      payload: { isloginLoader: true },
    });
    return new Promise((resolve, reject) => {
      api({ ...authenticate.login, body })
        .then((data: any) => {
          dispatch({
            type: AUTHENTICATE_LOGIN_ACTIONS.AUTHENTICATE_LOGIN_RESPONSE,
            payload: data[0],
          });
          if (data?.code === 200) {
            Toast({
              type: "success",
              message: "Login successfully",
              title: "success",
            });
            resolve(data);
          }
          else if (data?.message === "This email already logged.") {
            // Toast({
            //   type: "error",
            //   message: "",
            //   title: data.status,
            // });
            resolve(data);
          }
          else {
            // debugger;
            console.log(data);

            Toast({
              type: "error",
              message: data.message,
              title: data.status,
            });
            resolve(data);
          }
        })
        .catch((error) => {
          console.log("login error", error)
          let errorMessgae = ""
          errorMessgae = error.message ? error.message : "Something went wrong"
          let errorStatus = error?.status + " : " + error?.statusText
          Toast({
            type: "danger",
            message: errorStatus + ' | ' + error.message,
            title: "Error",
          });
          dispatch({
            type: AUTHENTICATE_LOGIN_ACTIONS.AUTHENTICATE_LOGIN_ERROR,
            payload: {},
          });
          reject(error?.status);
        });
    });
  };

export const getRefreshToken =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: AUTHENTICATE_REFRESH_TOKEN_ACTIONS.AUTHENTICATE_REFRESH_TOKEN_REQUEST,
      payload: { isRefreshLoader: true },
    });
    return new Promise((resolve, reject) => {
      api({ ...authenticate.refreshToken, body })
        .then((data: any) => {
          dispatch({
            type: AUTHENTICATE_REFRESH_TOKEN_ACTIONS.AUTHENTICATE_REFRESH_TOKEN_RESPONSE,
            payload: data[0],
          });
          console.log('getRefreshToken', data);

          resolve(data);
          if (data?.code === 200) {
            Toast({
              type: "success",
              message: "Register successfully",
              title: "success",
            });
          } else {
            Toast({
              type: "danger",
              message: data.message,
              title: data.status,
            });
            // reject(data?.data);
          }
        })
        .catch((error) => {
          console.log(error)
          let errorMessgae = ""
          errorMessgae = error.message ? error.message : "Something went wrong"
          let errorStatus = error?.status + " : " + error?.statusText
          Toast({
            type: "danger",
            message: errorStatus + ' | ' + error.message,
            title: "Error",
          });
          dispatch({
            type: AUTHENTICATE_REFRESH_TOKEN_ACTIONS.AUTHENTICATE_REFRESH_TOKEN_ERROR,
            payload: {},
          });
          reject(error);
        });
    });
  };

export const registerUser =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: AUTHENTICATE_REGISTER_ACTIONS.AUTHENTICATE_REGISTER_REQUEST,
      payload: { isRegisterLoader: true },
    });
    return new Promise((resolve, reject) => {
      api({ ...authenticate.registerUser, body })
        .then((data: any) => {
          dispatch({
            type: AUTHENTICATE_REGISTER_ACTIONS.AUTHENTICATE_REGISTER_RESPONSE,
            payload: data,
          });
          if (data?.status === "Error") {
            Toast({
              type: "error",
              message: data.message ? data.message : "Internal Server Error",
              title: "Error",
            });
          }
          else if (data?.code === 200) {
            Toast({
              type: "success",
              message: "Thank you. Please check your email to activate your account",
              title: "success",
            });
          }
          resolve(data);
        })
        .catch((error) => {
          // console.log(error);
          // console.log("error register-------->", error?.message);
          let errorMessgae = ""
          errorMessgae = error.message ? error.message : "Something went wrong"
          let errorStatus = error?.status + " : " + error?.statusText
          Toast({
            type: "danger",
            message: errorStatus + ' | ' + error.message,
            title: "Error",
          });
          dispatch({
            type: AUTHENTICATE_REGISTER_ACTIONS.AUTHENTICATE_REGISTER_ERROR,
            payload: {},
          });
          reject(error);
        });
    });
  };
// 2 device logout 
export const deviceLogOut =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: AUTHENTICATE_DEVICE_LOGOUT_ACTIONS.AUTHENTICATE_DEVICE_LOGOUT_REQUEST,
      payload: { isLogOutLoader: true },
    });
    return new Promise((resolve, reject) => {
      api({ ...authenticate.deviceLogout, body })
        .then((data: any) => {
          dispatch({
            type: AUTHENTICATE_DEVICE_LOGOUT_ACTIONS.AUTHENTICATE_DEVICE_LOGOUT_RESPONSE,
            payload: data,
          });
          Toast({
            type: "success",
            message: 'You have successfully logged out! ',
            title: "success",
          });
          resolve(data);
        })
        .catch((error) => {
          // console.log("error-------->", error?.message);
          Toast({
            type: "danger",
            message: error.message ? error.message : "Internal Server Error",
            title: "Error",
          });
          dispatch({
            type: AUTHENTICATE_DEVICE_LOGOUT_ACTIONS.AUTHENTICATE_DEVICE_LOGOUT_ERROR,
            payload: {},
          });
          reject(error);
        });
    });
  };
// user logout
export const userLogOut =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: AUTHENTICATE_LOGOUT_ACTIONS.AUTHENTICATE_LOGOUT_REQUEST,
      payload: { isLogOutLoader: true },
    });
    return new Promise((resolve, reject) => {
      stopTokenRefresh();
      api({ ...authenticate.logout, body })
        .then((data: any) => {
          dispatch({
            type: AUTHENTICATE_LOGOUT_ACTIONS.AUTHENTICATE_LOGOUT_RESPONSE,
            payload: data,
          });
          Toast({
            type: "success",
            message: 'You have successfully logged out! ',
            title: "success",
          });
          resolve(data);
        })
        .catch((error) => {
          // console.log("error-------->", error?.message);
          Toast({
            type: "danger",
            message: error?.message ? error.message : "Internal Server Error",
            title: "Error",
          });
          dispatch({
            type: AUTHENTICATE_LOGOUT_ACTIONS.AUTHENTICATE_LOGOUT_ERROR,
            payload: {},
          });
          reject(error);
        });
    });
  };

export const forgotPassword =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: AUTHENTICATE_FORGOT_ACTIONS.AUTHENTICATE_FORGOT_REQUEST,
      payload: { isForgotLoader: true },
    });
    return new Promise((resolve, reject) => {
      api({ ...authenticate.forgot, body })
        .then((data: any) => {
          dispatch({
            type: AUTHENTICATE_FORGOT_ACTIONS.AUTHENTICATE_FORGOT_RESPONSE,
            payload: data,
          });
          console.log(JSON.stringify(data));
          if (data.code === 200) {
            Toast({
              type: "success",
              message: "Email sent successfully",
              title: "success",
            });

            resolve(data);
          } else {
            Toast({
              type: "danger",
              message: data.message,
              title: data.status,
            });
            reject(data);
          }

        })
        .catch((error) => {
          // console.log(error)
          let errorMessgae = ""
          errorMessgae = error.message ? error.message : "Something went wrong"
          let errorStatus = error?.status + " : " + error?.statusText
          Toast({
            type: "danger",
            message: errorStatus + ' | ' + error.message,
            title: "Error",
          });
          dispatch({
            type: AUTHENTICATE_FORGOT_ACTIONS.AUTHENTICATE_FORGOT_ERROR,
            payload: {},
          });
          reject(error);
        });
    });

  };
export const resetPassword =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: AUTHENTICATE_RESET_ACTIONS.AUTHENTICATE_RESET_REQUEST,
      payload: { isForgotLoader: true },
    });
    return new Promise((resolve, reject) => {
      api({ ...authenticate.reset, body })
        .then((data: any) => {
          dispatch({
            type: AUTHENTICATE_RESET_ACTIONS.AUTHENTICATE_RESET_REQUEST,
            payload: data[0],
          });
          if (data.code === 200) {
            Toast({
              type: "success",
              message: "Reset password successfully",
              title: "success",
            });

            resolve(data);
          } else {
            Toast({
              type: "danger",
              message: data.message,
              title: data.status,
            });
            reject(data);
          }
        })
        .catch((error) => {
          console.log(error)
          let errorMessgae = ""
          errorMessgae = error.message ? error.message : "Something went wrong"
          let errorStatus = error?.status + " : " + error?.statusText
          Toast({
            type: "danger",
            message: errorStatus + ' | ' + error.message,
            title: "Error",
          });
          dispatch({
            type: AUTHENTICATE_RESET_ACTIONS.AUTHENTICATE_RESET_ERROR,
            payload: {},
          });
          reject(error);
        });
    });
  }
export const changeUserEmail =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: AUTHENTICATE_CHANGE_ACTIONS.AUTHENTICATE_CHANGE_REQUEST,
      payload: { isChangeEmailLoader: true },
    });
    return new Promise((resolve, reject) => {
      // const prefixUrl = `?email=${body?.email}&email_key=${body?.email_key}`
      api({ ...authenticate.updateEmail, body })
        .then((data: any) => {
          dispatch({
            type: AUTHENTICATE_CHANGE_ACTIONS.AUTHENTICATE_CHANGE_REQUEST,
            payload: data[0],
          });
          if (data.code === 200) {
            Toast({
              type: "success",
              message: "Email changed successfully",
              title: "success",
            });
            resolve(data);
          } else {
            Toast({
              type: "danger",
              message: data.message,
              title: data.status,
            });
            reject(data);
          }
        })
        .catch((error) => {
          let errorStatus = error?.status + " : " + error?.statusText
          Toast({
            type: "danger",
            message: errorStatus + ' | ' + error.message,
            title: "Error",
          });
          dispatch({
            type: AUTHENTICATE_RESET_ACTIONS.AUTHENTICATE_RESET_ERROR,
            payload: {},
          });
          reject(error);
        });
    });
  }
export const getEmailOTP =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: AUTHENTICATE_GETEMAIL_OTP_ACTIONS.AUTHENTICATE_GETEMAIL_OTP_REQUEST,
      payload: { isChangeEmailLoader: true },
    });
    return new Promise((resolve, reject) => {
      // const prefixUrl = `?email=${body?.email}&email_key=${body?.email_key}`
      api({ ...authenticate.OTP, body })
        .then((data: any) => {
          dispatch({
            type: AUTHENTICATE_GETEMAIL_OTP_ACTIONS.AUTHENTICATE_GETEMAIL_OTP_RESPONSE,
            payload: data[0],
          });
          if (data.code === 200) {
            Toast({
              type: "success",
              message: "Please check your mail and get your one time password.",
              title: "success",
            });
            resolve(data);
          } else {
            Toast({
              type: "danger",
              message: data.message,
              title: data.status,
            });
            reject(data);
          }
        })
        .catch((error) => {
          let errorStatus = error?.status + " : " + error?.statusText
          Toast({
            type: "danger",
            message: errorStatus + ' | ' + error.message,
            title: "Error",
          });
          dispatch({
            type: AUTHENTICATE_GETEMAIL_OTP_ACTIONS.AUTHENTICATE_GETEMAIL_OTP_ERROR,
            payload: {},
          });
          reject(error);
        });
    });
  }
export const activationEmail =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: AUTHENTICATE_ACTIVATE_ACTIONS.AUTHENTICATE_ACTIVATE_REQUEST,
      payload: { isForgotLoader: true },
    });
    return new Promise((resolve, reject) => {
      api({ ...authenticate.activation, body })
        .then((data: any) => {
          // Toast({
          //   type: "success",
          //   message: "Password Reset Successfully",
          //   title: "success",
          // });
          dispatch({
            type: AUTHENTICATE_ACTIVATE_ACTIONS.AUTHENTICATE_ACTIVATE_RESPONSE,
            payload: data[0],
          });
          resolve(data);
        })
        .catch((error) => {
          // Toast({
          //   type: "danger",
          //   message: "Invalid Email",
          //   title: "Error",
          // });
          dispatch({
            type: AUTHENTICATE_ACTIVATE_ACTIONS.AUTHENTICATE_ACTIVATE_ERROR,
            payload: {},
          });
          reject(error);
        });
    });
  };
export const resendActivationEmail =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: AUTHENTICATE_RESENDEMAIL_ACTIONS.AUTHENTICATE_RESENDEMAIL_REQUEST,
      payload: { isForgotLoader: true },
    });
    return new Promise((resolve, reject) => {
      const prefixUrl = `?email=${body?.email}`
      api({ ...authenticate.resendActivation, body, prefixUrl })
        .then((data: any) => {
          Toast({
            type: "success",
            message: "Confirmation email resent successfully. Please check your email",
            title: "success",
          });
          dispatch({
            type: AUTHENTICATE_RESENDEMAIL_ACTIONS.AUTHENTICATE_RESENDEMAIL_RESPONSE,
            payload: data[0],
          });
          resolve(data);
        })
        .catch((error) => {
          Toast({
            type: "danger",
            message: "Invalid Email",
            title: "Error",
          });
          dispatch({
            type: AUTHENTICATE_RESENDEMAIL_ACTIONS.AUTHENTICATE_RESENDEMAIL_ERROR,
            payload: {},
          });
          reject(error);
        });
    });
  };


export const getNotification =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: AUTHENTICATE_NOTIFICATION_ACTIONS.AUTHENTICATE_NOTIFICATION_REQUEST,
      payload: { isFollowBondLoader: true },
    });
    return new Promise((resolve, reject) => {
      api({ ...authenticate.notification, body })
        .then((data: any) => {
          dispatch({
            type: AUTHENTICATE_NOTIFICATION_ACTIONS.AUTHENTICATE_NOTIFICATION_RESPONSE,
            payload: data,
          });
          resolve(data);
        })
        .catch((error) => {
          console.log("Notification error", error);

          const errorStatus = error?.status ? error?.status : "" + " : " + error?.statusText ? error?.statusText : ""
          Toast({
            type: "danger",
            message: errorStatus + ' | ' + error?.message ? error.message : "",
            title: "Error",
          });
          dispatch({ type: AUTHENTICATE_NOTIFICATION_ACTIONS.AUTHENTICATE_NOTIFICATION_ERROR, payload: [] });
          resolve(error);
        });
    });
  };


export const NotificationRemove =
  (body: any, param: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: REMOVE_NOTIFICATION_ACTIONS.REMOVE_NOTIFICATION_REQUEST,
      payload: { isFollowBondLoader: true },
    });
    return new Promise((resolve, reject) => {
      console.log(param, "NotificationRemove");

      let prefixUrl = `?user_id=${param?.user_id}`;
      api({ ...authenticate.removeNoti, body, prefixUrl })
        .then((data: any) => {
          dispatch({
            type: REMOVE_NOTIFICATION_ACTIONS.REMOVE_NOTIFICATION_RESPONSE,
            payload: data,
          });
          resolve(data);
        })
        .catch((error) => {

          dispatch({ type: REMOVE_NOTIFICATION_ACTIONS.REMOVE_NOTIFICATION_ERROR, payload: [] });
          reject(error);
        });
    });
  };

export const loginOAuth =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: IS_USER_EXITS_ACTIONS.IS_USER_EXITS_REQUEST,
      payload: { isFollowBondLoader: true },
    });
    return new Promise((resolve, reject) => {
      let prefixUrl = `?Email=${body?.Email}`;
      api({ ...authenticate.isUserExists, body, prefixUrl })
        .then((data: any) => {
          dispatch({
            type: IS_USER_EXITS_ACTIONS.IS_USER_EXITS_RESPONSE,
            payload: data,
          });
          resolve(data);
        })
        .catch((error) => {

          dispatch({ type: IS_USER_EXITS_ACTIONS.IS_USER_EXITS_ERROR, payload: [] });
          reject(error);
        });
    });
  };
export const changeAccountPassword =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: CHANGE_ACCOUNT_PASSWORD_ACTIONS.CHANGE_ACCOUNT_PASSWORD_REQUEST,
      payload: { isChangePasswordLoader: true },
    });
    return new Promise((resolve, reject) => {
      api({ ...authenticate.changeAccountPassword, body, })
        .then((data: any) => {
          dispatch({
            type: CHANGE_ACCOUNT_PASSWORD_ACTIONS.CHANGE_ACCOUNT_PASSWORD_RESPONSE,
            payload: data,
          });
          resolve(data);
          Toast({
            type: data.code === 200 ? "success" : "danger",
            message: data.message,
            // title: "Error",
          })
        })
        .catch((error) => {
          dispatch({ type: CHANGE_ACCOUNT_PASSWORD_ACTIONS.CHANGE_ACCOUNT_PASSWORD_ERROR, payload: [] });
          reject(error);
        });
    });
  };
export const requestEmailChange =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: REQUEST_EMAIL_CHANGE_ACTIONS.REQUEST_EMAIL_CHANGE_REQUEST,
      payload: { isrequestEmailChangeLoader: true },
    });
    return new Promise((resolve, reject) => {
      api({ ...authenticate.requestEmailChange, body })
        .then((data: any) => {
          dispatch({
            type: REQUEST_EMAIL_CHANGE_ACTIONS.REQUEST_EMAIL_CHANGE_RESPONSE,
            payload: data,
          });
          resolve(data);
          Toast({
            type: data.code === 200 ? "success" : "danger",
            message: data.code === 200 ? "Request sent successfully! Please check your email" : data.message,
            // title: "Error",
          })
        })
        .catch((error) => {
          dispatch({ type: REQUEST_EMAIL_CHANGE_ACTIONS.REQUEST_EMAIL_CHANGE_ERROR, payload: [] });
          reject(error);
        });
    });
  };

export const checkIsUserNameOrEmailAvailable =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: IS_USER_NAME_OR_EMAIL_AVAILABLE_ACTIONS.IS_USER_NAME_OR_EMAIL_AVAILABLE_REQUEST,
      payload: { isUserNameOrEmailAvailableLoader: true },
    });
    return new Promise((resolve, reject) => {
      api({ ...authenticate.isUserNameAndEmailExists, body, })
        .then((data: any) => {
          dispatch({
            type: IS_USER_NAME_OR_EMAIL_AVAILABLE_ACTIONS.IS_USER_NAME_OR_EMAIL_AVAILABLE_RESPONSE,
            payload: data,
          });
          resolve(data);
          // Toast({
          //   type: data.code === 200 ? "success" : "danger",
          //   message: data.message,
          //   // title: "Error",
          // })
        })
        .catch((error) => {
          dispatch({ type: IS_USER_NAME_OR_EMAIL_AVAILABLE_ACTIONS.IS_USER_NAME_OR_EMAIL_AVAILABLE_ERROR, payload: [] });
          reject(error);
        });
    });
  };

export const getAuthenticateOAuthLogin =
  (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
      type: AUTHENTICATE_OAUTH_LOGIN_ACTIONS.AUTHENTICATE_OAUTH_LOGIN_REQUEST,
      payload: { isloginLoader: true },
    });
    return new Promise((resolve, reject) => {
      api({ ...authenticate.oAuthLogin, body })
        .then((data: any) => {
          dispatch({
            type: AUTHENTICATE_OAUTH_LOGIN_ACTIONS.AUTHENTICATE_OAUTH_LOGIN_RESPONSE,
            payload: data[0],
          });
          if (data?.code === 200) {
            Toast({
              type: "success",
              message: "Login successfully",
              title: "success",
            });
            resolve(data);
          }
          else if (data?.message === "This email already logged.") {
            Toast({
              type: "error",
              message: "",
              title: data.status,
            });
            resolve(data);
          }
          else {
            // debugger;
            Toast({
              type: "error",
              message: data.message,
              title: data.status,
            });
            resolve(data);
          }
        })
        .catch((error) => {
          console.log("login error", error)
          let errorMessgae = ""
          errorMessgae = error.message ? error.message : "Something went wrong"
          let errorStatus = error?.status + " : " + error?.statusText
          Toast({
            type: "danger",
            message: errorStatus + ' | ' + error.message,
            title: "Error",
          });
          dispatch({
            type: AUTHENTICATE_OAUTH_LOGIN_ACTIONS.AUTHENTICATE_OAUTH_LOGIN_ERROR,
            payload: {},
          });
          reject(error?.status);
        });
    });
  };